import { decodeHTML } from 'entities';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getRecruitsNeareast, postPAIAE010Choice, postPAIAE010DelChoice } from '../../services/Api';
import { decodeHTMLEntities, fixInvalidNbspInTag, getImageSrc, handlePrint } from '../../utils';
import ImageCheckFallback from './ImageCheckFallback';
import KakaoMap from './KakaoMap';
import Paragraphs from './Paragraphs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Lightbox from 'yet-another-react-lightbox';
import { Counter } from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/plugins/counter.css';
import 'yet-another-react-lightbox/styles.css';
import KakaoMapNear from './KakaoMapNear';


const RecruitPage = ({
    data,
    fetchData,
    decode,
    id,
    setIsPopupSendMailOpen,
    isPopupSendMailOpen,
    printRef,
    openPopup,
    setReceiver,
    companyType,
    recruitTime,
    location,
}) => {
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;

    const [hoveredImageSrc, setHoveredImageSrc] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(0);
    // lightbox
    const [openLightbox, setOpenLightbox] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [sliderSettings, setSliderSettings] = useState({
        speed: 500,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });
    const [isOpenPopupMap, setIsOpenPopupMap] = useState(false);
    const [myLocation, setMyLocation] = useState({ pointX: '', pointY: '' });
    const [listLocation, setListLocation] = useState([]);

    const handleImageClick = (index) => {
        setLightboxIndex(index);
        setOpenLightbox(true);
        setSliderSettings((prevSettings) => ({
            ...prevSettings,
            autoplay: false,
        }));
    };

    const lightboxSlides =
        Array.isArray(data.subBizImg) && data.subBizImg.length > 0
            ? data.subBizImg.map((fileName) => ({
                src: getImageSrc('recruit_photo', fileName),
                alt: fileName || 'Recruit Image',
            }))
            : [];

    useEffect(() => {
        if (sliderSettings.autoplay) {
            const interval = setInterval(() => {
                setHoveredIndex((prevIndex) =>
                    sliderSettings.infinite
                        ? (prevIndex + 1) % (data?.subBizImg?.length || 1)
                        : Math.min(prevIndex + 1, (data?.subBizImg?.length || 1) - 1),
                );
            }, sliderSettings.autoplaySpeed);

            return () => clearInterval(interval);
        }
    }, [sliderSettings.autoplay, sliderSettings.autoplaySpeed, sliderSettings.infinite, data?.subBizImg]);

    useEffect(() => {
        if (data?.subBizImg && data.subBizImg.length > 0) {
            setHoveredImageSrc(getImageSrc('recruit_photo', data.subBizImg[hoveredIndex]));
        }
    }, [hoveredIndex, data?.subBizImg]);

    const renderMethods = (...methods) => {
        const applyMethods = {
            '002': '전화접수',
            '003': '이메일접수',
            '004': 'FAX접수',
            '005': '우편접수',
        };

        return methods
            .filter((value) => value && value.includes('|'))
            .map((value, index) => {
                const [code, detail] = value.split('|');
                const method = applyMethods[code];
                if (code && detail) {
                    return (
                        <p key={index}>
                            {method}{' '}
                            <span style={{ color: '#076ecc', fontWeight: '600' }}>{detail}</span>
                        </p>
                    );
                }
                return null;
            });

    };

    const getDaysRemaining = (targetDate) => {
        const now = moment();
        const target = moment(targetDate);
        const daysLeft = target.endOf('day').diff(now.startOf('day'), 'days');
        if (daysLeft > 10) {
            return false;
        } else if (daysLeft === 0) return '오늘마감';
        else if (daysLeft === 1) return '내일마감';
        else {
            return `D-${Math.abs(daysLeft)}`;
        }
    };

    const removeStar = () => {
        postPAIAE010DelChoice(data.choiceSeq)
            .then(() => {
                fetchData();
            })
            .catch((error) => console.log(error));
    };

    const activeStar = () => {
        postPAIAE010Choice({ tblName: 'Recruit', refSeq: id, memberID: decode?.memberID })
            .then(() => {
                fetchData();
            })
            .catch((error) => console.log(error));
    };

    const splitRecruitFlow = (recruitFlow, data = {}) => {
        if (!recruitFlow) return [];

        // 1) Normalize: convert to string, replace &nbsp; / numeric HTML NBSP, remove newlines
        const normalized = String(recruitFlow)
            .replace(/&nbsp;|&#160;/g, ' ')
            .replace(/\r?\n/g, ' ')
            .trim();

        const parts = normalized
            .split(/(?=\d+차)/g)
            .map((p) => p.trim())
            .filter(Boolean);

        const formatted = parts.map((item, idx) => {
            const normalizedItem = item.replace(/\s+/g, ' ').trim();
            if (normalizedItem === '직접 입력' || normalizedItem === '직접입력') {
                const key = `recruitFlowTextOpen${idx + 1}`;
                return data[key] ?? normalizedItem;
            }
            return normalizedItem;
        });

        return formatted;
    };


    const formatHomeUrl = (url) => {
        if (!url) return null;
        const trimmedUrl = url.trim();

        // nếu URL bắt đầu bằng http:// hoặc https://
        if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
            return trimmedUrl;
        }

        // nếu URL có định dạng hợp lệ nhưng thiếu http:// hoặc https://
        if (/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(trimmedUrl)) {
            return `https://${trimmedUrl}`;
        }

        // nếu URL không hợp lệ, trả về null
        return null;
    };

    const recruitGradeOptions = [
        { value: '999', option: '학력선택' },
        { value: '001', option: '고등학교졸업' },
        { value: '002', option: '전문대학1년재중' },
        { value: '003', option: '전문대학2년재중' },
        { value: '004', option: '전문대학3년재중' },
        { value: '005', option: '전문대학졸업' },
        { value: '006', option: '대학교1년재중' },
        { value: '007', option: '대학교2년재중' },
        { value: '008', option: '대학교3년재중' },
        { value: '009', option: '대학교4년재중' },
        { value: '010', option: '대학교졸업(학사)' },
        { value: '011', option: '대학원재중' },
        { value: '012', option: '대학원졸업(석사)' },
        { value: '013', option: '대학원졸업(박사)' },
    ];
    const getRecruitGradeOptionByValue = (recruitGrade, recruitGradeEtc) => {
        const found = recruitGradeOptions.find(
            (item) =>
                (item.value !== '999' ? item.value : '' || item.option !== '학력선택' ? item.option : '') ===
                recruitGrade,
        );
        const resutl = found ? found.option : recruitGrade;
        if (recruitGrade === '999' || !recruitGrade) {
            return recruitGradeEtc;
        }
        if (recruitGradeEtc && resutl) {
            return `${resutl}, ${recruitGradeEtc}`;
        }
        return resutl;
    };

    const [showButtonMobile, setShowButtonMobile] = useState(true);
    const openNearLocation = () => {
        setShowButtonMobile(false); // hide button-mobile
        setIsOpenPopupMap(true);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log(position);

                    setMyLocation({
                        pointX: position.coords.longitude,
                        pointY: position.coords.latitude,
                    });

                    getRecruitsNeareast(
                        position.coords.longitude,
                        position.coords.latitude,
                    )
                        .then(({ data }) => {
                            setListLocation(data);
                        })
                        .catch((error) => console.log(error));
                },
                (error) => {
                    switch (error.code) {
                        case 1:
                            console.error(
                                'Error: Permission denied. Please enable location access.',
                            );
                            break;
                        case 2:
                            console.error(
                                'Error: Position unavailable. Please check your GPS or network.',
                            );
                            break;
                        case 3:
                            console.error(
                                'Error: Timeout. Unable to retrieve location.',
                            );
                            break;
                        default:
                            console.error(
                                'Error: Unknown error occurred while retrieving location.',
                            );
                    }
                },
                { enableHighAccuracy: false, timeout: 15000, maximumAge: 30000 },
            );
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    };



    return (
        <div className="job-content">
            <div className="job-info">
                <div className="job-left">
                    <div className="job-name">
                        <h2>
                            {data.logoFile && data.logoFile !== '' ? (
                                <ImageCheckFallback
                                    folderName="recruit_logo"
                                    imgName={data.logoFile}
                                    alt="logo recruit"
                                />
                            ) : (
                                data.companyName
                            )}
                            <div className="button-container">
                                {decode?.authorities === 'ROLE_P' && (
                                    <>
                                        <button
                                            type="button"
                                            className={`button-scrap ${data?.isChoice === 'Y' ? 'active' : ''}`}
                                            onClick={data?.isChoice === 'Y' ? removeStar : activeStar}
                                        >
                                            스크랩
                                        </button>
                                        <button
                                            type="button"
                                            className="button-msg"
                                            id="messageSendBtn"
                                            onClick={() => {
                                                setIsPopupSendMailOpen(!isPopupSendMailOpen);
                                                setReceiver({ id: data?.memberID, name: data?.companyName });
                                            }}
                                        >
                                            쪽지보내기
                                        </button>
                                        <div
                                            className="button-mobile"
                                            style={{ display: showButtonMobile ? '' : 'none' }}
                                        >
                                            <button
                                                type="button"
                                                className={`button-scrap ${data?.isChoice === 'Y' ? 'active' : ''}`}
                                                onClick={data?.isChoice === 'Y' ? removeStar : activeStar}
                                            ></button>
                                            <button
                                                type="button"
                                                className="button-msg"
                                                id="messageSendBtn"
                                                onClick={() => {
                                                    setIsPopupSendMailOpen(!isPopupSendMailOpen);
                                                    setReceiver({ id: data?.memberID, name: data?.nameKor });
                                                }}
                                            ></button>
                                            <Link className="button-map" onClick={openNearLocation}></Link>
                                            {data?.statusFlag === 'O' &&
                                                data?.applyMethod1 === '001' &&
                                                decode?.authorities === 'ROLE_P' && (
                                                    <div className="job-right">
                                                        {/* {getDaysRemaining(data?.recruitEnd) && (
                                                            <span className="job-dday">
                                                                {getDaysRemaining(data?.recruitEnd)}
                                                            </span>
                                                        )} */}
                                                        <Link onClick={openPopup} className="job-aplct-btn">
                                                            즉시지원
                                                        </Link>
                                                    </div>
                                                )}
                                        </div>
                                    </>
                                )}

                                <button
                                    type="button"
                                    className="button-print"
                                    onClick={() =>
                                        handlePrint(printRef, [
                                            '.button-container',
                                            '#nextImageBtn',
                                            '#prevImageBtn',
                                            '.rsm-print__btbx',
                                            '.rsm-mng__btn',
                                        ])
                                    }
                                >
                                    인쇄하기
                                </button>
                            </div>
                        </h2>
                        <h1>{data?.title}</h1>
                    </div>
                    <div className="job-detail-container">
                        <div className="job-detail-item">
                            <span>{data?.recruitClass}</span>
                        </div>
                        <div className="job-detail-item">
                            <ul>
                                <li>{data?.recruitCareer}</li>
                                <li>{data?.recruitForm}</li>
                                <li>{data?.recruitLicense}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                {data?.statusFlag === 'O' && data?.applyMethod1 === '001' && decode?.authorities === 'ROLE_P' && (
                    <div className="job-right">
                        {getDaysRemaining(data?.recruitEnd) && (
                            <span className="job-dday">{getDaysRemaining(data?.recruitEnd)}</span>
                        )}
                        <Link onClick={openPopup} className="job-aplct-btn">
                            입사지원
                        </Link>
                    </div>
                )}
            </div>
            <div className="company-info">
                <h3>기본정보</h3>
                <div className="job-div job__div-mt0">
                    <div className="job-imgbox">
                        {data?.subBizImg !== null ? (
                            <>
                                <ul className="recruit__photo-container">
                                    {data?.subBizImg &&
                                        data?.subBizImg.map((imageName, index) => {
                                            const src = getImageSrc('recruit_photo', imageName);
                                            return (
                                                <li
                                                    className={`recruit__photo-items ${hoveredIndex === index ? 'hovered' : ''
                                                        }`}
                                                    key={'recruit__photo' + index}
                                                    onMouseEnter={() => {
                                                        setHoveredImageSrc(src);
                                                        setHoveredIndex(index);
                                                        setSliderSettings((prevSettings) => ({
                                                            ...prevSettings,
                                                            autoplay: false,
                                                        }));
                                                    }}
                                                    onMouseLeave={() => {
                                                        setSliderSettings((prevSettings) => ({
                                                            ...prevSettings,
                                                            autoplay: true,
                                                        }));
                                                    }}
                                                >
                                                    <img src={src} alt="DentalJob Recruit" />
                                                </li>
                                            );
                                        })}
                                </ul>
                                <div className="magnify__container">
                                    <img
                                        src={
                                            hoveredImageSrc ||
                                            (Array.isArray(data?.subBizImg) && data?.subBizImg.length > 0
                                                ? getImageSrc('recruit_photo', data?.subBizImg[hoveredIndex])
                                                : './images/default_logo.jpg')
                                        }
                                        alt="Recruit"
                                        onClick={() => handleImageClick(hoveredIndex)}
                                    />
                                </div>
                            </>
                        ) : (
                            <img src="./images/default_logo.jpg" alt="Default Logo" />
                        )}
                    </div>
                    <table className="job-table">
                        <tbody>
                            <tr>
                                <th>사업자명</th>
                                <td>{data?.companyName}</td>
                            </tr>
                            <tr>
                                <th>사업장구분</th>
                                <td>{companyType}</td>
                            </tr>
                            <tr>
                                <th>대표자명</th>
                                <td>{data?.nameKor}</td>
                            </tr>
                            <tr>
                                <th>홈페이지</th>
                                <td>
                                    {formatHomeUrl(data?.homeUrl) ? (
                                        <a href={formatHomeUrl(data?.homeUrl)} target="_blank" rel="noreferrer">
                                            {data?.homeUrl}
                                        </a>
                                    ) : (
                                        <span>{data?.homeUrl}</span>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td>
                                    {`${data?.postNo ? `(${data?.postNo})` : ''} ${data?.addressRoad ? data?.addressRoad : ''
                                        } ${data?.addressDetail ? ` ${data?.addressDetail}` : ''}`}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3>치과소개</h3>
                <table className="job-table">
                    <tbody>
                        <tr>
                            <th>총 구성원수</th>
                            <td>{data?.compositionNum && `${data.compositionNum}명`}</td>
                        </tr>
                        <tr>
                            <th>구성원 설명</th>
                            <td style={{ whiteSpace: 'pre-line' }}>{data?.compositionDesc}</td>
                        </tr>
                        <tr>
                            <th>치과소개</th>
                            <td style={{ whiteSpace: 'pre-line' }}>{data?.bizDesc}</td>
                        </tr>
                    </tbody>
                </table>

                <h3>상세채용정보</h3>
                <table className="job-table">
                    <tbody>
                        <tr>
                            <th>담당업무</th>
                            <td>{data?.recruitClass}</td>
                        </tr>
                        <tr>
                            <th>필요자격증</th>
                            <td>{data?.recruitLicense}</td>
                        </tr>
                        <tr>
                            <th>근무형태</th>
                            <td>{data?.recruitForm}</td>
                        </tr>
                        <tr>
                            <th>모집인원</th>
                            <td>{`${data?.recruitNum || 0}명`}</td>
                        </tr>
                        <tr>
                            <th>직급</th>
                            <td>{data?.recruitPosition}</td>
                        </tr>
                        <tr>
                            <th>급여</th>
                            <td>
                                {data?.recruitPay === '' || data?.recruitPay === '직접입력'
                                    ? data?.recruitPayEtc
                                    : data?.recruitPay}
                            </td>
                        </tr>
                        <tr>
                            <th>자격요건</th>
                            {/* <td>
                                학력: {getRecruitGradeOptionByValue(data?.recruitGrade, data?.recruitGradeEtc)}<br />
                                경력:{' '}
                                {data?.recruitCareer === '경력' && data?.recruitCareerYear
                                    ? `경력 (${data?.recruitCareerYear
                                        .split('_')
                                        .map((item, index) => (index === 0 ? item : `~${item}`))
                                        .join('')}년)`
                                    : data?.recruitCareer}
                            </td> */}
                            <td>
                                학력: {getRecruitGradeOptionByValue(data?.recruitGrade)}<br />
                                {data?.recruitGradeEtc && (
                                    <>
                                        기타 학력조건: {data.recruitGradeEtc}<br />
                                    </>
                                )}
                                경력:{' '}
                                {data?.recruitCareer === '경력' && data?.recruitCareerYear
                                    ? `경력 (${data?.recruitCareerYear
                                        .split('_')
                                        .map((item, index) => (index === 0 ? item : `~${item}`))
                                        .join('')}년)`
                                    : data?.recruitCareer}
                            </td>

                        </tr>
                        <tr id='content-detail'>
                            <th>세부사항</th>
                            <td>
                                {/* <div dangerouslySetInnerHTML={{ __html: decodeHTML(data?.contents) }}></div> */}
                                <div
                                    className="contents"
                                    style={{ whiteSpace: 'pre-line' }}
                                    dangerouslySetInnerHTML={{
                                        __html: fixInvalidNbspInTag(
                                            decodeHTMLEntities(data?.contents)
                                        )
                                    }}
                                />

                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="job-div job-div--gap30 pt30">
                    <div className="job-column">
                        <h3>근무환경 / 복리후생</h3>
                        <table className="job-table" style={{ height: 'calc(100% - 32px)' }}>
                            <tbody>
                                <tr>
                                    <th>근무요일</th>
                                    <td>
                                        {data?.recruitDay?.includes('직접입력') || data?.recruitDay?.includes('999')
                                            ? data?.recruitDayEtc
                                            : data?.recruitDay}
                                    </td>
                                </tr>
                                {recruitTime && (
                                    <tr>
                                        <th>{recruitTime ? '근무시간' : ''}</th>
                                        <td className="job-timeinfo">
                                            <Paragraphs content={recruitTime} />
                                        </td>
                                    </tr>
                                )}
                                {data?.assist1 && data?.assist1.length > 0 && (
                                    <tr>
                                        <th>생활편의지원</th>
                                        <td>{data?.assist1}</td>
                                    </tr>
                                )}
                                {data?.assist2 && data?.assist2.length > 0 && (
                                    <tr>
                                        <th>경조사지원</th>
                                        <td>{data?.assist2}</td>
                                    </tr>
                                )}
                                {data?.assist3 && data?.assist3.length > 0 && (
                                    <tr>
                                        <th>교육여가지원</th>
                                        <td>{data?.assist3}</td>
                                    </tr>
                                )}
                                {data?.assist4 && data?.assist4.length > 0 && (
                                    <tr>
                                        <th>보험지원</th>
                                        <td>{data?.assist4}</td>
                                    </tr>
                                )}
                                {data?.assist5 && data?.assist5.length > 0 && (
                                    <tr>
                                        <th>보상수당지원</th>
                                        <td>{data?.assist5}</td>
                                    </tr>
                                )}
                                {data?.conditionEtc !== '' && (
                                    <tr>
                                        <th>기타 근무조건</th>
                                        <td style={{ whiteSpace: 'pre-line' }}>
                                            {decodeHTML(decodeHTMLEntities(data?.conditionEtc))}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <h3>접수방법</h3>
                <table className="job-table">
                    <tbody>
                        <tr>
                            <th>모집기간</th>
                            <td>
                                <span className="blue-bold">
                                    {moment(data?.recruitFrom).format('yyyy-MM-DD')} ~{' '}
                                    {moment(data?.recruitEnd).format('yyyy-MM-DD')}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>접수방법</th>
                            <td style={{ maxWidth: '100%' }}>
                                <p>{data?.applyMethod1 === '001' && '덴탈잡온라인 채용시스템 접수'}</p>
                                {renderMethods(
                                    data?.applyMethod2,
                                    data?.applyMethod3,
                                    data?.applyMethod4,
                                    data?.applyMethod5,
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>제출서류</th>
                            <td>
                                {String(data?.needPaper ?? '').trim() === '직접입력'
                                    ? data?.needPaperEtc
                                    : data?.needPaper}
                            </td>

                        </tr>


                        {data?.recruitFlow ? (
                            <tr>
                                <th>전형방법</th>
                                <td>
                                    {splitRecruitFlow(decodeHTML(decodeHTMLEntities(data?.recruitFlow))).map(
                                        (item, index) => (
                                            <p key={`recruitFlow${index}`}>{item}</p>
                                        ),
                                    )}
                                </td>
                            </tr>
                        ) : (
                            ''
                        )}
                    </tbody>
                </table>
                {loggedIn && (

                    <div className="job-column job-column--mt20">
                        <h3>채용담당자 정보</h3>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th>담당자명</th>
                                    <td>{data?.charge}</td>
                                </tr>
                                <tr>
                                    <th>담당자 이메일</th>
                                    <td>
                                        {data?.chargeEmail}
                                    </td>
                                </tr>
                                <tr>
                                    <th>전화번호</th>
                                    <td>{data?.chargeTel}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
                <h3>근무위치</h3>
                <table className="job-table">
                    <tbody>
                        {data?.regionSi && data?.regionGu && (
                            <tr>
                                <th>근무지</th>
                                <td>
                                    {data.regionSi} {data.regionGu} {data.regionDetail || ''}
                                </td>
                            </tr>
                        )}

                        <tr>
                            <th>인근 지하철역</th>
                            <td>
                                {[
                                    { num: data?.subwayNum1, post: data?.subwayPost1 },
                                    { num: data?.subwayNum2, post: data?.subwayPost2 },
                                    { num: data?.subwayNum3, post: data?.subwayPost3 },
                                ]
                                    .filter((subway) => subway.num && subway.post)
                                    .map((subway, index) => (
                                        <p key={`subway-${index}`}>
                                            {subway.num} {subway.post}
                                        </p>
                                    ))}
                            </td>
                        </tr>
                        {data?.bizAddrDesc ? (
                            <tr>
                                <th>위치설명</th>
                                <td>{data?.bizAddrDesc}</td>
                            </tr>
                        ) : (
                            ''
                        )}
                        {data?.mapSvr === 'Y' && (
                            <tr>
                                <th>상세지도</th>
                                <td>
                                    <div className="table-horizontal">
                                        <li>
                                            <div className="table-content" style={{ padding: '0px' }}>
                                                <div
                                                    className="map-container"
                                                    style={{ width: '100%', height: '400px' }}
                                                >
                                                    <KakaoMap location={location} />
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="company-info">
                <div className="job-point">
                    <p>
                        <span>
                            덴탈잡에서는 남녀고용평등과 일·가정 양립 지원에 관한 법률에 의거 성별 및 나이에 대한 정보를
                            표시하지 않습니다.
                        </span>
                    </p>
                    <p>
                        <span>
                            본 정보는 <b>{data?.companyName ? data?.companyName : ''}</b>에서 제공한 자료이며{' '}
                            <b>덴탈잡</b>은 기재된 내용에 대한 오류와 사용자가 이를 신뢰하여 취한 조치에 대한 책임을
                            지지 않습니다.
                        </span>
                    </p>
                    <p>
                        <span>
                            본 정보는 어떠한 경우라도 <b>덴탈잡</b>이나{' '}
                            <b>{data?.companyName ? data?.companyName : ''}</b>의 동의없이 무단전재 및 재배포할 수
                            없으며, 채용 목적 이외의 용도로 사용할 수 없습니다.
                        </span>
                    </p>
                    <p>
                        <span>
                            본 정보를 출력, 복사, 유출한 경우 개인정보보호에 대한 책임은 출력, 복사, 유출 행위를 한
                            당사자에게 있으며 정보통신부 고시 제2005-18호에 따라 법에 의해
                            <br />
                            책임을 지게 됨을 양지하시기 바랍니다.
                        </span>
                    </p>
                </div>
            </div>
            <Lightbox
                open={openLightbox}
                close={() => {
                    setOpenLightbox(false);
                    setSliderSettings((prevSettings) => ({
                        ...prevSettings,
                        autoplay: true,
                    }));
                }}
                slides={lightboxSlides}
                index={lightboxIndex}
                plugins={[Counter]}
                carousel={{ finite: true, padding: '15%' }}
                styles={{
                    container: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    },
                }}
            />
            {
                isOpenPopupMap && (
                    <div className="popupMapContainer">
                        <button className="closeMapBtn" onClick={() => {
                            setIsOpenPopupMap(false);
                            setShowButtonMobile(true);
                        }}></button>
                        <KakaoMapNear myLocation={myLocation} listLocation={listLocation} />
                    </div>
                )
            }
        </div >
    );
};
export default RecruitPage;
